import { render } from "./OneProductCarouselItem.vue?vue&type=template&id=2a7b9dd0&scoped=true"
import script from "./OneProductCarouselItem.vue?vue&type=script&lang=js"
export * from "./OneProductCarouselItem.vue?vue&type=script&lang=js"

import "./OneProductCarouselItem.vue?vue&type=style&index=0&id=2a7b9dd0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7b9dd0"]])

export default __exports__